module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "noPadding"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-offset-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showmobileguide),
      expression: "showmobileguide"
    }],
    key: "mobileinfo"
  }, [_c('p', {
    attrs: {
      "id": "welcomeInfoText"
    }
  }, [_vm._v(" \n\t\t\t\t\tA Horrifying Halloween Sound Experiment.\n\t\t\t\t")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-blackwhite btn-lg",
    attrs: {
      "id": "playButton"
    },
    on: {
      "click": _vm.startAudio
    }
  }, [_c('strong', [_vm._v(" Click To Scare, If You Dare. ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showmobileguide),
      expression: "showmobileguide"
    }],
    key: "mobileinfo"
  }, [_c('p', {
    attrs: {
      "id": "welcomeMobileText"
    }
  }, [_c('i', {
    class: _vm.bellSlash
  }), _vm._v(" "), _c('br'), _vm._v(" \n\t\t      \tPlease make sure your "), _c('strong', [_vm._v(" mute button is off ")]), _vm._v(" and volume is engaged.\n\t\t\t\t"), _c('br'), _vm._v(" "), _c('br')])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4b907b8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcome.vue
// module id = 20
// module chunks = 0